'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  component: _propTypes2.default.string
};

var defaultProps = {
  component: 'h3'
};

var ListHeader = function ListHeader(_ref) {
  var className = _ref.className,
      children = _ref.children,
      component = _ref.component,
      otherProps = _objectWithoutProperties(_ref, ['className', 'children', 'component']);

  var classes = (0, _classnames2.default)('mdc-list-group__subheader', className);
  return _react2.default.createElement(component, _extends({
    className: classes
  }, otherProps), children);
};
ListHeader.propTypes = propTypes;
ListHeader.defaultProps = defaultProps;
exports.default = ListHeader;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-mdc-web/lib/List/ListHeader.js
// module id = 279
// module chunks = 0